import "../styles/Booking.css";

export default function BookingFailed() {
    return (
        <div className="vkv-shell">
            <div className="vkv-card vkv-card--error">

                <div className="vkv-error-icon">✕</div>
                <div className="vkv-eyebrow" style={{ color: "#FF3800" }}>
          // PAYMENT CANCELLED
                </div>
                <div className="vkv-title">
                    ORDER<br />CANCELLED
                </div>
                <p className="vkv-sub">
                    Your payment was not completed and no charges have been made.
                    Return to tours to try again, or contact us if you think this
                    was an error.
                </p>

                <div className="vkv-failed-actions">
                    <a href="/missions" className="vkv-btn">BACK TO TOURS ▶</a>
                    <a href="/contact" className="vkv-btn vkv-btn--ghost">CONTACT US</a>
                </div>

            </div>
        </div>
    );
}